// extracted by mini-css-extract-plugin
module.exports = {"container":"view-module--container--2SXp1","page":"view-module--page---Bsvk","footer":"view-module--footer--28vcg"};